export default {
  methods: {
    redirectToLogin(user_sub_domain = null) {
      this.$store.commit('NEW', {
        type: 'success',
        message: this.$t(`toast.REDIRECT_TO_SIGN_IN`),
      })
      let site = window.location.host
      let sub_domain = user_sub_domain ? user_sub_domain : 'app'
      let domain = currentDomainType(site)
      if (
        domain === siteConstants.MYQAMPUS_BETA_STATIC_SITE ||
        domain === siteConstants.MYQAMPUS_PROD_STATIC_SITE
      ) {
        if (site.startsWith('www.')) {
          site = site.replace('www.', '')
        }
        window.location.replace(`https://${sub_domain}.${site}/signin`)
      }
    },
    redirectToQuizSignUp() {
      this.$store.commit('NEW', {
        type: 'success',
        message: 'Redirecting to Sign Up Page',
      })
      let site = window.location.host
      site = site.replace(/myqampus/g, 'myquriosity')
      window.open(`https://${site}/signup`, '_blank')
    },
  },
}
